import React, { useEffect, useState } from 'react';
import mova from 'mova';
import './BuyCertificate.scss';
import Loading from '@components/feedback/Loading/Loading';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SvgIcon from '../../components/display/SvgIcon/SvgIcon';
import { getCertificates } from '@store/actions/place';
import PropTypes from 'prop-types';
import CertificateCard from '../../components/display/CertificateCard/CertificateCard';
import { baseUrlPath } from '@utils/url/urlUtils';
import Button from '../../components/inputs/Button/Button';
import TextInput from '../../components/inputs/TextInput/TextInput';
import PhoneInput from '../../components/inputs/PhoneInput/PhoneInput';
import Form from '../../components/inputs/Form/Form';
import { phoneRegexp } from '../../../utils/validation/validationUtils';
import api from '@api';
import { get } from '@utils/lo/lo';
import { v4 as uuidv4 } from 'uuid';

const t = mova.ns('pages.BuyCertificate');

const BuyCertificate = ({ history, match, getCertificates, certificates, user }) => {
  const [certificate, setCertificate] = useState(null);

  const { placeUri, certificateId } = match.params;

  const goBackToPlace = () => {
    history.push(`${baseUrlPath()}/places/${placeUri}`);
  };

  useEffect(() => {
    if (placeUri) {
      getCertificates(placeUri);
    }
  }, [placeUri, getCertificates]);

  useEffect(() => {
    if (certificates.length) {
      setCertificate(certificates.find(c => c.id === +certificateId));
    }
  }, [certificates, certificateId]);

  if (!certificate) {
    return <Loading />;
  }

  const goToPayment = (data) => {
    const clientId = uuidv4().substring(0, 8);
    const body = {
      ...data,
      certificateId,
      clientId,
      successUrl: `${window.location.origin}${baseUrlPath()}/payment-success/${clientId}`,
      failedUrl: window.location.href,
    };
    api.billing.buyCertificate(placeUri, body).then(async ({ data }) => {
      window.location = data.paymentLink;
    });
  };

  return (
    <div className='buy-certificate'>
      <div className='buy-certificate__container'>
        <div className='buy-certificate__title'>
          <SvgIcon type='chevronDown' className='buy-certificate__title-icon' onClick={goBackToPlace} />
          <div>{t('title')}</div>
        </div>
        <CertificateCard certificate={certificate} />
        <Form onValidSubmit={goToPayment} className='buy-certificate__form'>
          <TextInput
            placeholder={t('fields.name')}
            name='firstName'
            fullWidth
            fontSize={16}
            value={user?.firstName}
            required
            validationErrors={{
              isDefaultRequiredValue: t('errors.required')
            }}
          />
          <TextInput
            placeholder={t('fields.surname')}
            name='lastName'
            value={user?.lastName}
            fullWidth
            fontSize={16}
          />
          <PhoneInput
            name='phone'
            fullWidth
            required
            value={user?.phone}
            validations={{
              matchRegexp: phoneRegexp
            }}
            validationErrors={{
              matchRegexp: t('errors.phone'),
              isDefaultRequiredValue: t('errors.required')
            }}
            fetchCountry
          />
          <div className='buy-certificate__check-phone'>{t('checkPhone')}</div>
          <TextInput
            name='email'
            placeholder={t('fields.email')}
            fullWidth
            fontSize={16}
            value={user?.email}
            validations='isEmail'
            validationErrors={{
              isEmail: t('errors.email'),
            }}
          />
          <div>
            <Button fullWidth size='large' behavior='submit'>{t('pay')}</Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

BuyCertificate.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  getCertificates: PropTypes.func.isRequired,
  certificates: PropTypes.array.isRequired,
  user: PropTypes.object,
};

BuyCertificate.defaultProps = {
  user: null,
};

const mapStateToProps = ({ place, user }) => ({
  certificates: (place.certificates.data || []).filter(c => c.active),
  user: get(user, 'details.data.user'),
});

const mapDispatchToProps = {
  getCertificates,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BuyCertificate));
